/**
 * Shared visual tones for Orders (Kanban + table).
 * Status → System pastels; Type → Secondary pastels (independent of status).
 */

export type OrderStatusTone = "neutral" | "info" | "success" | "error";

export type OrderTypeTone = "pickup" | "delivery" | "neutral";

/** Lane / status accent — matches Kanban lane chrome. */
export const getOrderStatusTone = (status: string): OrderStatusTone => {
    switch (status) {
        case "PENDING":
            return "neutral";
        case "APPROVED":
        case "READY":
        case "ASSIGNED":
        case "DELIVERY_STARTED":
            return "info";
        case "DELIVERED":
        case "DELIVERY_FINISHED":
            return "success";
        case "DECLINED":
        case "REFUNDED":
        case "VOID":
            return "error";
        default:
            return "neutral";
    }
};

/** Normalize legacy lane color keys (`metalic` → `neutral`). */
export const normalizeStatusTone = (tone: string): OrderStatusTone => {
    if (tone === "metalic") return "neutral";
    if (
        tone === "neutral" ||
        tone === "info" ||
        tone === "success" ||
        tone === "error"
    ) {
        return tone;
    }
    return "neutral";
};

/** Order fulfillment type badge — purple = pickup, blue = delivery. */
export const getOrderTypeTone = (
    type: string | null | undefined,
): OrderTypeTone => {
    const normalized = (type || "").trim().toUpperCase();
    if (normalized === "PICKUP") return "pickup";
    if (normalized === "DELIVERY") return "delivery";
    return "neutral";
};
